/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Subscription and license information.
 * @export
 * @interface GetServiceprovider200ResponseLicense
 */
export interface GetServiceprovider200ResponseLicense {
    /**
     * Current subscription status.
     */
    subscriptionStatus: GetServiceprovider200ResponseLicenseSubscriptionStatusEnum;
    /**
     * Number of available client seats under the current license.
     */
    freeSeats: number;
    /**
     * License mode.
     */
    mode?: string;
}


/**
 * @export
 */
export const GetServiceprovider200ResponseLicenseSubscriptionStatusEnum = {
    Active: 'active',
    Trialing: 'trialing',
    NoSubscription: 'no_subscription',
} as const;
export type GetServiceprovider200ResponseLicenseSubscriptionStatusEnum = typeof GetServiceprovider200ResponseLicenseSubscriptionStatusEnum[keyof typeof GetServiceprovider200ResponseLicenseSubscriptionStatusEnum];


/**
 * Check if a given object implements the GetServiceprovider200ResponseLicense interface.
 */
export function instanceOfGetServiceprovider200ResponseLicense(value: object): value is GetServiceprovider200ResponseLicense {
    if (!('subscriptionStatus' in value) || value['subscriptionStatus'] === undefined) return false;
    if (!('freeSeats' in value) || value['freeSeats'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseLicenseFromJSON(json: any): GetServiceprovider200ResponseLicense {
    return GetServiceprovider200ResponseLicenseFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200ResponseLicense {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionStatus': json['subscriptionStatus'],
        'freeSeats': json['freeSeats'],
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function GetServiceprovider200ResponseLicenseToJSON(json: any): GetServiceprovider200ResponseLicense {
    return GetServiceprovider200ResponseLicenseToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseLicenseToJSONTyped(value?: GetServiceprovider200ResponseLicense | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionStatus': value['subscriptionStatus'],
        'freeSeats': value['freeSeats'],
        'mode': value['mode'],
    };
}

